__turbopack_context__.v({
  "navHeading": "ContentPageNavigation-module-scss-module__NpXfMq__navHeading",
  "navHeadingContainer": "ContentPageNavigation-module-scss-module__NpXfMq__navHeadingContainer",
  "navItemButtonsContainer": "ContentPageNavigation-module-scss-module__NpXfMq__navItemButtonsContainer",
  "navItemOpenButton": "ContentPageNavigation-module-scss-module__NpXfMq__navItemOpenButton",
  "navItemOpenButtonClosed": "ContentPageNavigation-module-scss-module__NpXfMq__navItemOpenButtonClosed",
  "navItemSelected": "ContentPageNavigation-module-scss-module__NpXfMq__navItemSelected",
  "navigationLevel": "ContentPageNavigation-module-scss-module__NpXfMq__navigationLevel",
  "navigationLevelHidden": "ContentPageNavigation-module-scss-module__NpXfMq__navigationLevelHidden",
});
